import React from 'react';

const Page = React.lazy(() => import('./PaymentReportPage'));

const PaymentReportConfig = {
	settings: { layout: { config: {} } },
	routes: [
		{
			path: '/billing/reports/payments',
			element: (
				<React.Suspense fallback={<>...</>}>
					<Page />
				</React.Suspense>
			),
		},
	],
	auth: ['school_admin', 'super_school_admin', 'sub_admin'],
};

export default PaymentReportConfig;
